import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Home, KeyRound, Plus } from "lucide-react";
import { Link, matchPath, useLocation, useNavigate } from "react-router";

// IDEM Stage 0 mobile nav. Trimmed to the Leads view + new-lead + change
// password. Atomic's contacts/tasks/notes create sheets and their nav targets
// don't exist on the spine.

export const MobileNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const onLeads =
    !!matchPath("/", location.pathname) || !!matchPath("/leads/*", location.pathname);

  const isPwa = window.matchMedia("(display-mode: standalone)").matches;
  const isWebiOS = /iPad|iPod|iPhone/.test(window.navigator.userAgent);

  return (
    <nav
      aria-label="Navigation"
      className="fixed bottom-0 left-0 right-0 z-50 bg-secondary h-14"
      style={{ paddingBottom: isPwa && isWebiOS ? 15 : undefined }}
    >
      <div className="flex justify-center items-center gap-4">
        <NavigationButton href="/leads" Icon={Home} label="Leads" isActive={onLeads} />
        <Button
          variant="default"
          size="icon"
          className="h-16 w-16 rounded-full -mt-3"
          aria-label="New lead"
          onClick={() => navigate("/leads/create")}
        >
          <Plus className="size-10" />
        </Button>
        <NavigationButton
          href="/change-password"
          Icon={KeyRound}
          label="Password"
          isActive={!!matchPath("/change-password", location.pathname)}
        />
      </div>
    </nav>
  );
};

const NavigationButton = ({
  href,
  Icon,
  label,
  isActive,
}: {
  href: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  isActive: boolean;
}) => (
  <Button
    asChild
    variant="ghost"
    className={cn(
      "flex-col gap-1 h-auto py-2 px-1 rounded-md w-16",
      isActive ? null : "text-muted-foreground",
    )}
  >
    <Link to={href}>
      <Icon className="size-6" />
      <span className="text-[0.6rem] font-medium">{label}</span>
    </Link>
  </Button>
);
